import styled from "@emotion/styled";
import React, { useEffect, useState, useCallback } from "react";
import TextareaAutosize from "react-textarea-autosize";
import { SendIcon } from "./SVGIcons";
import useAppStore from "../appStore";

const ChatInput = ({ sendMessage }) => {
  const [disabled, setDisabled] = useState(true);
  const [message, setMessage] = useState("");
  const isAITyping = useAppStore((state) => state.isAITyping);

  const handleSendMessage = useCallback(() => {
    console.log("handleSendMessage2")
    if (message.trim().length <= 0) return;
    if (isAITyping) return;
    sendMessage(message);
    setMessage("");
  }, [message, sendMessage, isAITyping]);

  const handleKeyPress = useCallback(
    (e) => {
      if (e.key === "Enter" && !e.shiftKey && message.length > 0) {
        e.preventDefault();
        handleSendMessage();
      }
    },
    [handleSendMessage, message.length]
  );

  useEffect(() => {
    if (message.length > 0) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [message]);

  return (
    <StyledChatInput>
      <ChatWrapper>
        <StyledInput
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder={isAITyping ? "Typing..." : "Type a message..."}
          onKeyDown={handleKeyPress}
        />
        <SendButton onClick={handleSendMessage}>
          <StyledSendIcon disabled={disabled} />
        </SendButton>
      </ChatWrapper>
    </StyledChatInput>
  );
};

const StyledChatInput = styled.div`
  position: absolute;
  bottom: 14px;
  width: 100%;
  display: flex;
  justify-content: center;
`;
const StyledInput = styled(TextareaAutosize)`
  box-shadow: ${(props) => props.theme.shadows.chat};
  width: 372px;
  border: none;
  border-radius: 27px;
  padding: 16px;
  padding-right: 50px;
  resize: none;
  font-family: "Inter", sans-serif;
  color: ${(props) => props.theme.colors.primary};

  &:focus,
  &:active {
    outline: none;
  }
  &::placeholder {
    color: ${(props) => props.theme.colors.lightPrimary};
    font-family: "Inter", sans-serif;
  }
`;

const ChatWrapper = styled.div`
  position: relative;
`;

const SendButton = styled.button`
  position: absolute;
  bottom: 10px;
  right: 16px;
  background: none;
`;

const StyledSendIcon = styled(SendIcon)`
  width: 25px;
  height: 25px;
  path {
    fill: ${(props) =>
      props.disabled
        ? props.theme.colors.lightPrimary
        : props.theme.colors.primary};
  }
`;
export default ChatInput;
